import { GetInstanceInfoByInstanceIdRequest } from '@amzn/aws-hammerstone-exposed-restful-service-typescript-client/clients/hammerstoneexposedrestfulservicelambda';
import { Header, SpaceBetween, Tabs } from '@amzn/awsui-components-console';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { fetchActivityInfo, fetchInstanceById } from '../../data/api/fetchFromAPI';
import InstanceContainerLayout from './InstanceContainerLayout';
import PAGES from '../../nav/Pages';
import { urlSearchString } from '../../nav/navHelper';
import { RefreshButton, HammerstoneAppLayout } from '../helpers';
import { useGroupName, useInstance } from 'src/data/redux';
import { useAddInstanceToRecentPages } from 'src/commons';
import { DisplayMode } from '../helpers/content/contentInterfaces';
import RerunExecutionInstanceButton from './RerunExecutionInstanceButton';
import LogsNavigator from '../helpers/LogsNavigator';

export default function ViewInstance() {
	const { activityId, instanceId } = useParams();
	const groupName = useGroupName();
	const navigate = useNavigate();

	const { data: instance, fetching } = useInstance(instanceId);
	const loading = fetching;

	const fetchInput: GetInstanceInfoByInstanceIdRequest = {
		instanceId,
		groupName,
		activityId: parseInt(activityId),
	};

	useEffect(() => {
		//Refresh the instance upon mounting the component
		fetchInstanceById(fetchInput);
		//Also fetches activity and to get pipeline name for breadcrumbs, and faster loading thru the breadcrumbs
		fetchActivityInfo({ activityId: parseInt(activityId), groupName });
	}, [groupName]);

	useAddInstanceToRecentPages(activityId, instanceId, groupName);

	return (
		<HammerstoneAppLayout {...PAGES.VIEW_INSTANCE.pageLayoutProps({ instanceId, activityId })}>
			<SpaceBetween size="xl">
				<Header
					variant="h1"
					actions={
						<SpaceBetween direction="horizontal" size="xs">
							<RefreshButton
								refreshing={loading}
								onRefresh={() => {
									fetchInstanceById(fetchInput, true);
								}}
							/>
							<RerunExecutionInstanceButton
								{...{ activityId, instanceId }}
								onSuccess={(output) => {
									fetchActivityInfo({ activityId: parseInt(activityId), groupName }, true);

									const newInstanceId = output?.resource?.instanceId;
									if (newInstanceId) {
										navigate({
											pathname: PAGES.VIEW_INSTANCE.path
												.replace(':instanceId', newInstanceId)
												.replace(':activityId', activityId),
											search: urlSearchString({ groupName }),
										});
									}
								}}
							/>
						</SpaceBetween>
					}
				>
					{loading ? <span className="missing-data">loading instance ...</span> : instanceId}
				</Header>

				<Tabs
					tabs={[
						{
							label: 'Overview',
							id: 'overview',
							content: (
								<InstanceContainerLayout
									instanceId={instanceId}
									mode={loading ? DisplayMode.Loading : DisplayMode.View}
								/>
							),
						},
						{
							label: 'Worker Service logs',
							id: 'ws_logs',
							content: <LogsNavigator logs={instance?.workerServiceLogsList} loading={fetching} />,
						},
						{
							label: 'RMS logs',
							id: 'rms_logs',
							content: <LogsNavigator logs={instance?.rmsLogsList} loading={fetching} />,
						},
					]}
				/>
			</SpaceBetween>
		</HammerstoneAppLayout>
	);
}
